import { render, staticRenderFns } from "./ParcelsTable.vue?vue&type=template&id=8b863b18&scoped=true"
import script from "./ParcelsTable.vue?vue&type=script&lang=js"
export * from "./ParcelsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b863b18",
  null
  
)

export default component.exports